<tec-tile
    type="status"
    [title]="'WORKFLOWS.FORM.READY.TITLE' | translate"
    [subtitle]="'WORKFLOWS.FORM.READY.DESCRIPTION' | translate"
    tagIconStatus="success"
    icon="icon-check"
>
    <div class="buttons">
        <tec-button [label]="'BUTTON.EDIT' | translate" type="secondary" (click)="edit()" />
        <tec-button
            [label]="'WORKFLOWS.FORM.READY.TEST_WORKFLOW' | translate"
            icon="icon-play"
            (click)="testWorkflow()"
        />
    </div>

    @if (isProduction) {
        <tec-alert [msg]="'WORKFLOWS.FORM.READY.ALERT' | translate : { url: integrationUrl }" [hiddenCloseButton]="true" />
    }

    <tec-link [label]="'WORKFLOWS.FORM.READY.SKIP_TEST' | translate" (click)="skipTest()" />
</tec-tile>

@if (workflow) {
    <app-modal-create-process [workflow]="workflow" [workflowResponse]="data.value" (closeEvent)="workflow = undefined" />
}
